export default __webpack_public_path__ + "static/media/creative-mob.791942d6.png";